module.exports = __webpack_public_path__ + "static/media/29COICT9.1fe42156.jpg";